import React, { useState, useEffect } from "react";
import { X, Banknote, Trash, Plus } from "lucide-react";

export default function BudgetModal({ show, onClose, info, setInfo, t }) {
  const [tempBudget, setTempBudget] = useState([]);

  // Kai modalas atsidaro, sinchronizuojame duomenis iš pagrindinio "info" objekto
  useEffect(() => {
    if (show) {
      if (info.budgetDetails && info.budgetDetails.length > 0) {
        setTempBudget([...info.budgetDetails]);
      } else {
        setTempBudget([{ id: Date.now(), desc: "", quantity: "", price: "", sum: "" }]);
      }
    }
  }, [show, info.budgetDetails]);

  const parseNumber = (value) => {
    if (!value) return 0;
    const str = value.toString().replace(',', '.');
    const match = str.match(/-?\d+(\.\d+)?/);
    return match ? parseFloat(match[0]) : 0;
  };

  const handleBudgetRowChange = (id, field, value) => {
    setTempBudget(prev => prev.map(item => {
      if (item.id !== id) return item;
      const updatedItem = { ...item, [field]: value };
      if (field === 'quantity' || field === 'price') {
        const q = parseNumber(updatedItem.quantity);
        const p = parseNumber(updatedItem.price);
        if (q !== 0 && p !== 0) {
          updatedItem.sum = (q * p).toFixed(2);
        }
      }
      return updatedItem;
    }));
  };

  const addBudgetRow = () => {
    setTempBudget(prev => [...prev, { id: Date.now(), desc: "", quantity: "", price: "", sum: "" }]);
  };

  const removeBudgetRow = (id) => {
    setTempBudget(prev => prev.filter(item => item.id !== id));
  };

  const calculateTotal = () => {
    return tempBudget.reduce((acc, item) => acc + parseNumber(item.sum), 0);
  };

  const saveBudget = () => {
    const total = calculateTotal();
    const formattedTotal = total.toFixed(2) + " €";
    setInfo(prev => ({
      ...prev,
      projektwert: formattedTotal,
      budgetDetails: tempBudget
    }));
    onClose();
  };

  if (!show) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="budget-modal" onClick={e => e.stopPropagation()}>
        <div className="budget-header">
          <h2><Banknote size={20}/> {t('project_budget')}</h2>
          <button onClick={onClose}><X size={24}/></button>
        </div>
        <div className="budget-body">
          <div className="budget-table-header">
            <span className="bh-desc">{t('description')}</span>
            <span className="bh-qty">{t('quantity')}</span>
            <span className="bh-price">{t('price')}</span>
            <span className="bh-sum">{t('sum')} (€)</span>
            <span className="bh-action"></span>
          </div>
          <div className="budget-list">
            {tempBudget.map((item) => (
              <div key={item.id} className="budget-row">
                <input className="b-input" placeholder="..." value={item.desc} onChange={(e) => handleBudgetRowChange(item.id, 'desc', e.target.value)}/>
                <input className="b-input" placeholder="0" value={item.quantity} onChange={(e) => handleBudgetRowChange(item.id, 'quantity', e.target.value)}/>
                <input className="b-input" placeholder="0.00" value={item.price} onChange={(e) => handleBudgetRowChange(item.id, 'price', e.target.value)}/>
                <input className="b-input" placeholder="0.00" value={item.sum} readOnly/>
                <button className="b-trash" onClick={() => removeBudgetRow(item.id)}><Trash size={18}/></button>
              </div>
            ))}
            <button className="add-row-btn" onClick={addBudgetRow}><Plus size={16}/> {t('add_line')}</button>
          </div>
          <div className="budget-footer-summary">
            <span>{t('total')}:</span>
            <span className="total-sum">{calculateTotal().toFixed(2)} €</span>
          </div>
        </div>
        <div className="budget-actions">
          <button className="m-btn cancel" onClick={onClose}>{t('cancel')}</button>
          <button className="m-btn save" onClick={saveBudget}>{t('save')}</button>
        </div>
      </div>
    </div>
  );
}